import { makeStyles } from "@cirrus/ui-kit"

import { cx } from "ramda-extension/es"
import React from "react"

import { Icon } from "@cirrus/legacy/app-components/entries/lib.js"

import cv from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"

const useStyles = makeStyles({
  hint: {
    display: "flex",
    alignItems: "center",
    background: cv.gray50,
    minHeight: "50px",
    padding: "13px 15px",
    fontWeight: "bold",
    border: `1px solid ${cv.gray600}`,
    margin: "10px 0 15px 0",
  },

  infoIcon: {
    fontSize: "24px",
    verticalAlign: "top",
    marginRight: "10px",
    color: cv.gray890,
  },
})

const Hint = ({ containerClassName, iconClassName, hintText }) => {
  const classes = useStyles()

  const containerClassNames = cx(classes.hint, containerClassName)
  const iconClassNames = cx(classes.infoIcon, iconClassName)

  return (
    <div className={containerClassNames}>
      <Icon className={iconClassNames} icon="fa-info-circle" />
      {hintText}
    </div>
  )
}

export default Hint
